<template>
  <router-link :to="contractRoute" :class="classModifiers">
    <div class="market-contract-v2__title" v-contract-name>
      {{ title }}
    </div>
    <span class="market-contract-v2__current-price">
      <template v-if="hasLastTradePrice">
        <animated-number :value="price"></animated-number>
      </template>
      <template v-else> -<span v-html="'&cent;'"></span> </template>
    </span>
    <market-change-price
      :price="changePrice"
      :lastClosePrice="contractModel.lastClosePrice"
    ></market-change-price>
  </router-link>
</template>

<script src="./market-contract-v2.js"></script>
<style src="./market-contract-v2.scss" lang="scss"></style>
